/* FIT — Shopify cart integration.
 * Wires the cart drawer to Shopify's AJAX Cart API.
 * Exposes window.FIT = { openCart, closeCart, addItem, checkout, refresh, addUpsell, addMagnetPads, addWarranty, addLifetime, addLoxxKit, addLoxxUpgrade }.
 * Upsell variant IDs are injected by layout/theme.liquid as window.FIT_UPSELLS (null when the product doesn't exist yet).
 * build: js-zero-err-20260804c — no double-CDN fit-shop-grid-fix inject
 */
(function(){
  const state = { cart: null };
  const UP = window.FIT_UPSELLS || {};

  async function refresh(){
    try {
      const r = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
      state.cart = await r.json();
    } catch (e){ state.cart = { items: [], total_price: 0, item_count: 0 }; }
    render();
    return state.cart;
  }

  async function addItem(variantId, quantity = 1, properties = {}){
    if (!variantId) return;
    await addItems([{ id: variantId, quantity, properties }]);
  }

  /** Batch add — one cart open, one refresh (avoids race when ATC adds cover + LOXX + bundle). */
  async function addItems(lines){
    const items = (lines || [])
      .filter(l => l && l.id)
      .map(l => ({
        id: Number(l.id),
        quantity: l.quantity || 1,
        properties: l.properties || {}
      }));
    if (!items.length) throw new Error('no-items');
    let r;
    try {
      r = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items })
      });
    } catch (netErr) {
      throw new Error('network');
    }
    if (!r.ok) {
      let detail = '';
      try { detail = await r.text(); } catch (e) {}
      const err = new Error('add-failed');
      err.status = r.status;
      err.detail = detail;
      throw err;
    }
    try { await refresh(); } catch (e) { /* cart still added */ }
    try { openCart(); } catch (e) { window.location.href = '/cart'; }
  }

  async function changeItem(line, quantity){
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line, quantity })
    });
    await refresh();
  }

  function money(cents){ return '$' + (cents/100).toFixed(2).replace(/\.00$/, ''); }

  function inCart(variantId){
    if (!variantId || !state.cart) return false;
    return state.cart.items.some(it => it.variant_id === Number(variantId));
  }

  function render(){
    const pane = document.getElementById('cartItems');
    const count = document.getElementById('cartCount');
    const headCount = document.getElementById('cartHeadCount');
    const subtotal = document.getElementById('cartSubtotal');
    const c = state.cart;
    if (!c) return;
    if (count){ count.textContent = c.item_count || '0'; }
    if (headCount) headCount.textContent = c.item_count || '0';
    if (subtotal) subtotal.textContent = money(c.total_price);

    // Progress strip — covers ship free to the lower 48; accessory-only orders pay standard shipping.
    const progLabel = document.getElementById('cartProgLabel');
    const progPct = document.getElementById('cartProgPct');
    const progBar = document.getElementById('cartProgBar');
    const hasCover = c.items.some(it => it.sku && !/^ACC-/.test(it.sku));
    if (progLabel && c.item_count > 0 && hasCover){
      progLabel.textContent = 'Free shipping to the lower 48 — unlocked';
      if (progPct) progPct.textContent = '✓';
      if (progBar) progBar.style.width = '100%';
    } else if (progLabel && c.item_count > 0){
      progLabel.textContent = 'Accessories ship at standard rates — add a cover for free shipping (lower 48)';
      if (progPct) progPct.textContent = '';
      if (progBar) progBar.style.width = '0%';
    } else if (progLabel){
      progLabel.textContent = 'Free shipping to the lower 48 on every cover';
      if (progPct) progPct.textContent = '';
      if (progBar) progBar.style.width = '0%';
    }

    // Upsell discipline (Apple-simple cart):
    // 1) LOXX swap for Mag UTV/Jeep only
    // 2) Else one soft accessory (cleaner)
    // 3) Never stack LOXX + warranty + pads + cleaner
    const loxxEl = document.getElementById('cartLoxxUpsell');
    const cleanerEl = document.getElementById('cartUpsell');
    const padsEl = document.getElementById('cartMagnetPads');
    const warrantyEl = document.getElementById('cartWarrantyUpsell');
    const hide = (el) => { if (el) el.style.display = 'none'; };
    hide(loxxEl); hide(cleanerEl); hide(padsEl); hide(warrantyEl);

    if (c.item_count > 0){
      const swappable = c.items.some(it => it.sku && /^(UTV|JP)-/.test(it.sku) && /-(BK|CF)$/.test(it.sku));
      if (loxxEl && swappable && !inCart(UP.loxxUpgrade)){
        loxxEl.style.display = '';
      } else if (cleanerEl && UP.cleaner && !inCart(UP.cleaner)){
        cleanerEl.style.display = '';
      }
      // pads + warranty: available on accessories page only — not cart noise
    }

    if (!pane) return;
    if (!c.items.length){
      pane.innerHTML = '<p style="padding:40px;text-align:center;color:var(--muted)">Your cart is empty.</p>';
      return;
    }
    pane.innerHTML = c.items.map((it, idx) => {
      const props = it.properties || {};
      const propKeys = Object.keys(props).filter(k => props[k] != null && String(props[k]).length && k.charAt(0) !== '_');
      const propHtml = propKeys.length ? `<div style="margin-top:6px;font-size:11.5px;line-height:1.45;color:var(--slate-700)">${propKeys.map(k => {
        const val = String(props[k]);
        const isUrl = /^https?:\/\//i.test(val);
        const isPhoto = /^photo\s*\d/i.test(k) || /photo links/i.test(k);
        if (isUrl && (isPhoto || /^https?:\/\//i.test(val))) {
          return `<div><b>${k}:</b> <a href="${val}" target="_blank" rel="noopener" style="color:var(--bluestone-700);word-break:break-all">${isPhoto ? 'View photo ↗' : val}</a></div>`;
        }
        if (/photo links/i.test(k) && val.indexOf('http') !== -1) {
          const links = val.split(/\s*\|\s*/).filter(u => /^https?:\/\//i.test(u));
          return `<div><b>${k}:</b> ${links.map((u,i) => `<a href="${u}" target="_blank" rel="noopener" style="color:var(--bluestone-700)">Photo ${i+1} ↗</a>`).join(' · ')}</div>`;
        }
        return `<div><b>${k}:</b> ${val.length > 120 ? val.slice(0, 120) + '…' : val}</div>`;
      }).join('')}</div>` : '';
      return `
      <div class="cart-item" data-line="${idx+1}">
        <a href="${it.url || '#'}" style="flex-shrink:0"><img src="${it.image || ''}" alt="" style="width:72px;height:72px;object-fit:cover;border-radius:8px;background:var(--bone)"></a>
        <div style="flex:1;min-width:0">
          <a href="${it.url || '#'}" style="color:inherit;text-decoration:none"><div style="font-weight:600;font-size:14px">${it.product_title}</div></a>
          <div style="color:var(--muted);font-size:12px">${it.variant_title && it.variant_title !== 'Default Title' ? it.variant_title : ''}</div>
          ${it.sku ? `<div style="color:var(--muted);font-size:10.5px;letter-spacing:.05em;margin-top:2px">${it.sku}</div>` : ''}
          ${propHtml}
          <div style="display:flex;align-items:center;gap:12px;margin-top:8px">
            <div class="qty-stepper small">
              <button type="button" data-act="minus">−</button>
              <span>${it.quantity}</span>
              <button type="button" data-act="plus">+</button>
            </div>
            <button type="button" data-act="remove" style="background:none;border:0;color:var(--muted);font-size:12px;cursor:pointer;text-decoration:underline">Remove</button>
          </div>
        </div>
        <div style="font-weight:700">${money(it.final_line_price)}</div>
      </div>`;
    }).join('');
  }

  function openCart(){
    document.getElementById('cartDrawer')?.classList.add('open');
    document.getElementById('cartOverlay')?.classList.add('open');
    document.getElementById('cartDrawer')?.setAttribute('aria-hidden', 'false');
    /* Clarity: stream to Secure Checkout — focus primary CTA when drawer opens */
    try {
      var co = document.getElementById('cartCheckoutBtn');
      if (co) setTimeout(function(){ try { co.focus({ preventScroll: true }); } catch (e) {} }, 200);
    } catch (e2) {}
  }
  function closeCart(){
    document.getElementById('cartDrawer')?.classList.remove('open');
    document.getElementById('cartOverlay')?.classList.remove('open');
    document.getElementById('cartDrawer')?.setAttribute('aria-hidden', 'true');
  }
  function checkout(){ window.location.href = '/checkout'; }

  document.addEventListener('click', async (e) => {
    try {
      const t = e.target;
      if (t.matches('[data-cart-open]') || t.closest('[data-cart-open]')){ e.preventDefault(); openCart(); return; }
      if (t.matches('[data-cart-close]') || t.closest('[data-cart-close]')){ e.preventDefault(); closeCart(); return; }
      const row = t.closest('.cart-item');
      if (!row) return;
      if (!state.cart || !state.cart.items) { try { await refresh(); } catch (eR) { return; } }
      const line = parseInt(row.dataset.line, 10);
      const item = state.cart && state.cart.items ? state.cart.items[line - 1] : null;
      if (!item) return;
      const act = t.dataset.act || (t.closest && t.closest('[data-act]') && t.closest('[data-act]').dataset.act);
      if (act === 'plus') await changeItem(line, item.quantity + 1);
      if (act === 'minus') await changeItem(line, Math.max(0, item.quantity - 1));
      if (act === 'remove') await changeItem(line, 0);
    } catch (err) {
      try { console.warn('cart click', err); } catch (e2) {}
    }
  });

  // LOXX cart upsell: swap the cover line to its real -LX variant so the order
  // books as one LOXX cover SKU (production reads the SKU). Only falls back to
  // the standalone $49 upgrade line when no LX variant exists for that cover.
  async function addLoxxUpgrade(){
    const c = state.cart || await refresh();
    const cover = (c.items || []).find(it => it.sku && /^(UTV|JP)-/.test(it.sku) && /-(BK|CF)$/.test(it.sku));
    if (cover){
      let lxSku = null;
      if (/-BK$/.test(cover.sku)) lxSku = cover.sku.replace(/-BK$/, '-LX');
      else if (/-CF$/.test(cover.sku)) lxSku = cover.sku + '-LX';
      if (lxSku){
        try {
          const p = await (await fetch('/products/' + cover.handle + '.js', { headers: { Accept: 'application/json' } })).json();
          const lx = (p.variants || []).find(v => v.sku === lxSku);
          if (lx && lx.available !== false){
            const line = c.items.indexOf(cover) + 1;
            const q = cover.quantity;
            const props = cover.properties || {};
            await changeItem(line, 0);
            await addItem(lx.id, q, props);
            return;
          }
        } catch(e){ /* fall through to standalone upgrade line */ }
      }
    }
    addItem(UP.loxxUpgrade);
  }

  window.FIT = {
    openCart, closeCart, addItem, addItems, checkout, refresh,
    addUpsell(){ addItem(UP.cleaner); },
    addMagnetPads(){ addItem(UP.magnetPads); },
    addWarranty(){ addItem(UP.warranty); },
    addLifetime(){ addItem(UP.lifetime); },
    addLoxxKit(){ addItem(UP.loxxKit); },
    addLoxxUpgrade
  };
  document.addEventListener('DOMContentLoaded', refresh);
})();

/* ===== Mobile: body padding when fixed bottom bars are visible (sticky CTA / ATC) ===== */
(function(){
  function syncStickyPad(){
    try {
      var sticky = document.querySelector('.sticky-mobile-cta.visible');
      var atc = document.querySelector('.mobile-atc-bar');
      var cfg = document.getElementById('cfgStickyBar');
      var atcOn = atc && window.getComputedStyle(atc).display !== 'none';
      var cfgOn = cfg && !cfg.hidden && window.getComputedStyle(cfg).display !== 'none';
      // PDP / custom-fit already pad via their own body classes — still flag for shared CSS
      if (sticky || atcOn || cfgOn) document.body.classList.add('has-sticky-cta');
      else document.body.classList.remove('has-sticky-cta');
    } catch (e) {}
  }
  function boot(){
    syncStickyPad();
    var sticky = document.getElementById('stickyCta') || document.querySelector('.sticky-mobile-cta');
    if (sticky && window.MutationObserver){
      new MutationObserver(syncStickyPad).observe(sticky, { attributes: true, attributeFilter: ['class'] });
    }
    var cfg = document.getElementById('cfgStickyBar');
    if (cfg && window.MutationObserver){
      new MutationObserver(syncStickyPad).observe(cfg, { attributes: true, attributeFilter: ['hidden', 'class', 'style'] });
    }
    window.addEventListener('scroll', syncStickyPad, { passive: true });
    window.addEventListener('resize', syncStickyPad, { passive: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();

/* ===== Video modal — [data-yt-modal] opens local mp4 or YouTube id; [data-yt-portrait] for vertical ===== */
(function(){
  let modal = null;
  function ensureModal(){
    if (modal) return modal;
    modal = document.createElement('div');
    modal.id = 'ytModal';
    modal.className = 'yt-modal';
    modal.setAttribute('aria-hidden','true');
    modal.innerHTML =
      '<div class="yt-modal-backdrop" data-yt-close></div>'+
      '<div class="yt-modal-dialog">'+
        '<button type="button" class="yt-modal-close" data-yt-close aria-label="Close video">'+
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg>'+
        '</button>'+
        '<div class="yt-modal-frame" role="dialog" aria-modal="true" aria-label="Video player"></div>'+
      '</div>';
    document.body.appendChild(modal);
    const frame = modal.querySelector('.yt-modal-frame');
    const close = () => {
      modal.classList.remove('open');
      modal.setAttribute('aria-hidden','true');
      frame.innerHTML = '';
      document.documentElement.style.overflow = '';
    };
    modal.addEventListener('click', e => { if (e.target.closest('[data-yt-close]')) close(); });
    document.addEventListener('keydown', e => { if (e.key === 'Escape' && modal.classList.contains('open')) close(); });
    const buildYT = (ytId) => {
      const ifr = document.createElement('iframe');
      ifr.src = 'https://www.youtube-nocookie.com/embed/' + ytId + '?rel=0&autoplay=1&playsinline=1';
      ifr.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
      ifr.allowFullscreen = true;
      ifr.title = 'FIT Protection video';
      return ifr;
    };
    modal._open = (id, portrait) => {
      frame.classList.toggle('portrait', !!portrait);
      frame.innerHTML = '';
      if (!id) return;
      // Normalize protocol-relative CDN URLs so <video> always loads on https
      let src = String(id).trim();
      if (src.indexOf('//') === 0) src = 'https:' + src;
      const isYtId = /^[\w-]{6,20}$/.test(src) && src.indexOf('.') === -1 && src.indexOf('/') === -1;
      const isFile = !isYtId && (/\.(mp4|webm|mov)(\?|#|$)/i.test(src) || /\/cdn\/|\.myshopify\.com\//i.test(src));
      if (isFile){
        const vid = document.createElement('video');
        vid.src = src;
        vid.controls = true; vid.autoplay = true; vid.playsInline = true; vid.muted = false;
        vid.setAttribute('playsinline','');
        vid.setAttribute('preload','auto');
        vid.style.cssText = 'width:100%;height:100%;object-fit:contain;background:#000;display:block';
        // If local mp4 fails, fall back to known YouTube hold-test
        vid.addEventListener('error', () => {
          try {
            frame.innerHTML = '';
            frame.appendChild(buildYT('TV7gO41VEz0'));
          } catch (e) {}
        }, { once: true });
        frame.appendChild(vid);
        vid.play().catch(()=>{});
      } else if (isYtId || src){
        const ytId = isYtId ? src : src;
        frame.appendChild(buildYT(ytId));
      }
      modal.classList.add('open');
      modal.setAttribute('aria-hidden','false');
      document.documentElement.style.overflow = 'hidden';
    };
    return modal;
  }
  document.addEventListener('click', e => {
    const el = e.target.closest('[data-yt-modal]');
    if (!el) return;
    e.preventDefault();
    ensureModal()._open(el.getAttribute('data-yt-modal'), el.hasAttribute('data-yt-portrait'));
  });
})();

/* Mobile/tablet only: pin journey hero. Desktop uses hero-desktop-column.jpg from CSS. */
(function forceMobileJourneyHero(){
  function apply(){
    if(!document.body||!document.body.classList.contains("index-body")) return;
    if(document.getElementById("fit-hero-mobile-journey-js")) return;
    var s=document.createElement("style");
    s.id="fit-hero-mobile-journey-js";
    s.textContent="@media (max-width:900px){.hero-visual::before{background-image:url('https://fitprotection.com/cdn/shop/t/102/assets/hero-loxx-journey-final.jpg')!important;background-size:cover!important;background-position:center 38%!important;background-repeat:no-repeat!important}}";
    (document.head||document.documentElement).appendChild(s);
  }
  if(document.readyState==="loading") document.addEventListener("DOMContentLoaded",apply);
  else apply();
})();



/* shield-only: never inject FIT wordmark into header logo */
(function(){
  function strip(){
    try{
      document.querySelectorAll('a.logo.logo-home .logo-home-word, a.logo.logo-home > span').forEach(function(el){ el.remove(); });
    }catch(e){}
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',strip); else strip();
  setTimeout(strip,200);
})();

/* Sticky mobile CTA: single Find My Cover on homepage */
(function(){
  function fixHomeShell(){
    try {
      if (!document.body) return;
      var path = (location.pathname || '/').replace(/\/+$/, '') || '/';
      if (path !== '/') return;
      var sticky = document.getElementById('stickyCta');
      if (!sticky) return;
      var inner = sticky.querySelector('.sticky-mobile-cta-inner') || sticky;
      inner.classList.add('sticky-single');
      var secondary = sticky.querySelector('a.s-secondary');
      if (secondary) secondary.remove();
      var primary = sticky.querySelector('a.s-primary') || sticky.querySelector('a');
      if (primary) {
        primary.id = primary.id || 'stickyFindCover';
        primary.setAttribute('href', '#fitment');
        primary.innerHTML = 'Find My Cover <span aria-hidden="true">→</span>';
      }
    } catch (e) {}
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fixHomeShell);
  else fixHomeShell();
  setTimeout(fixHomeShell, 200);
})();

/* Fitment Find button: always tappable; incomplete → open Brand/Model */
(function(){
  function openSelect(sel){
    if (!sel) return;
    try {
      sel.focus({ preventScroll: false });
      if (typeof sel.showPicker === 'function') sel.showPicker();
    } catch (e) {
      try { sel.focus(); } catch (e2) {}
    }
  }
  function guideFind(){
    var brand = document.getElementById('fitBrand');
    var model = document.getElementById('fitModel');
    var hint = document.getElementById('fitHint');
    if (hint) {
      hint.textContent = 'Tap Brand, then Model — then Configure appears.';
      hint.classList.add('show');
    }
    if (brand && !brand.value) openSelect(brand);
    else if (model) openSelect(model);
    else if (brand) openSelect(brand);
  }
  function patch(){
    try {
      var btn = document.getElementById('fitFindBtn');
      if (btn) {
        btn.style.setProperty('pointer-events', 'auto', 'important');
        btn.style.setProperty('cursor', 'pointer', 'important');
        if (!btn.__fitFindPatched) {
          btn.__fitFindPatched = true;
          btn.addEventListener('click', function(e){
            var blocked = btn.classList.contains('is-blocked') || btn.getAttribute('aria-disabled') === 'true';
            var href = (btn.getAttribute('href') || '');
            if (blocked || href === '#fitment' || href === '' || href === '#') {
              e.preventDefault();
              e.stopPropagation();
              guideFind();
            }
          }, true);
        }
      }
      var label = document.getElementById('fitBarLabel') || document.querySelector('.hero-fitment-label');
      if (label && !label.__fitLabelPatched) {
        label.__fitLabelPatched = true;
        label.style.cursor = 'pointer';
        label.addEventListener('click', function(e){
          e.preventDefault();
          guideFind();
        });
      }
      /* Model empty option label */
      var model = document.getElementById('fitModel');
      if (model && model.options && model.options[0] && !model.options[0].value) {
        if (model.options[0].textContent !== 'Model') model.options[0].textContent = 'Model';
      }
    } catch (e) {}
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', patch);
  else patch();
  setTimeout(patch, 200);
  setTimeout(patch, 800);
})();


/* One-shot: replace stale homepage home-main with live section (same theme) */
(function(){
  function isHome(){
    var p=(location.pathname||'/').replace(/\/+$/,'')||'/';
    return p==='/'||p==='/index';
  }
  function needs(){
    var el=document.getElementById('fitment');
    if(!el) return true;
    // Bump version to force stale cached homepages to re-fetch live fitment + catalog wiring
    var v=el.getAttribute('data-fit-home')||'';
    return v!=='v43-catalog-ready';
  }
  function runScripts(root){
    if(!root) return;
    root.querySelectorAll('script').forEach(function(old){
      var s=document.createElement('script');
      if(old.src){s.src=old.src;s.async=false;} else s.textContent=old.textContent||'';
      old.parentNode.replaceChild(s,old);
    });
  }
  function go(){
    try{
      if(!isHome()||!needs()||window.__FIT_HOME_LIVE) return;
      window.__FIT_HOME_LIVE=true;
      fetch('/?sections=home-main-live',{credentials:'same-origin',cache:'no-store'})
        .then(function(r){return r.json();})
        .then(function(data){
          var html=data&&data['home-main-live'];
          if(!html||html.indexOf('data-fit-home="v43-catalog-ready"')===-1) return;
          var target=document.getElementById('shopify-section-home-main')
            ||document.getElementById('shopify-section-home-main-live')
            ||(document.getElementById('fitment')&&document.getElementById('fitment').closest('[id^="shopify-section"]'))
            ||document.getElementById('MainContent');
          if(!target) return;
          var tmp=document.createElement('div');
          tmp.innerHTML=html;
          var fresh=tmp.firstElementChild||tmp;
          if(target.id==='MainContent'){
            // replace first child section only
            var old=target.querySelector('[id^="shopify-section"]')||target.firstElementChild;
            if(old) old.replaceWith(fresh); else target.prepend(fresh);
          } else {
            target.replaceWith(fresh);
          }
          runScripts(fresh);
          document.body.setAttribute('data-fit-home-live','v41');
        }).catch(function(){});
    }catch(e){}
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',go); else go();
  setTimeout(go,400);
})();

/* fit-shop-grid-fix is loaded from layout via asset_url — do not inject a second
   CDN URL here (Shopify.cdnHost already includes /cdn → double-path console errors). */

/* Collection page_cache rehydrate: replace stale main section when storefront HTML lags theme */
(function(){
  function isCollection(){
    return /^\/collections\//.test(location.pathname||'');
  }
  function isStale(){
    try {
      var html = document.documentElement && document.documentElement.innerHTML || '';
      if (html.indexOf('col-stat:nth-of-type(3)') !== -1) return true;
      if (html.indexOf('function setText') === -1 && html.indexOf('id="shopGrid"') !== -1) return true;
      if (html.indexOf('js-zero-err-20260804c') === -1 && html.indexOf('fit-col-cache') !== -1) return true;
      return false;
    } catch (e) { return false; }
  }
  function runScripts(root){
    if (!root) return;
    root.querySelectorAll('script').forEach(function(old){
      var s = document.createElement('script');
      if (old.src) { s.src = old.src; s.async = false; }
      else s.textContent = old.textContent || '';
      old.parentNode.replaceChild(s, old);
    });
  }
  function go(){
    try {
      if (!isCollection() || window.__FIT_COL_LIVE || !isStale()) return;
      var target = document.querySelector('#MainContent [id^="shopify-section-template"]')
        || document.querySelector('#MainContent [id^="shopify-section-"]')
        || document.querySelector('[id^="shopify-section-template"]');
      if (!target || !target.id) return;
      var key = target.id.replace(/^shopify-section-/, '');
      window.__FIT_COL_LIVE = true;
      var url = location.pathname + (location.search ? location.search + '&' : '?') + 'sections=' + encodeURIComponent(key);
      fetch(url, { credentials: 'same-origin', cache: 'no-store', headers: { 'Accept': 'application/json' } })
        .then(function(r){ return r.json(); })
        .then(function(data){
          var html = data && data[key];
          if (!html || html.indexOf('function setText') === -1) return;
          var tmp = document.createElement('div');
          tmp.innerHTML = html;
          var fresh = tmp.firstElementChild || tmp;
          target.replaceWith(fresh);
          runScripts(fresh);
          document.body.setAttribute('data-fit-col-live', 'js-zero-err-20260804c');
        })
        .catch(function(){});
    } catch (e) {}
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', go);
  else go();
  setTimeout(go, 300);
})();
